import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { useNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';
import { Stack, stackingOrder } from '@alfa-bank/site-stack';
import { TooltipDesktop as CoreTooltip } from '@alfalab/core-components-tooltip/desktop';

import type { TTooltipCommon, IDeps } from './models';
import { Tooltip as Component } from './tooltip';
import styles from './styles/styles.css';

export const Tooltip = createWidget<IDeps, TTooltipCommon>({
    Stack,
    stackingOrder,
    CoreTooltip,
    useNamedContainersWithChildren,
    styles,
})(Component);
